import { render, staticRenderFns } from "./SuspendedScreen.vue?vue&type=template&id=36c1664c&scoped=true"
import script from "./SuspendedScreen.vue?vue&type=script&lang=js"
export * from "./SuspendedScreen.vue?vue&type=script&lang=js"
import style0 from "./SuspendedScreen.vue?vue&type=style&index=0&id=36c1664c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c1664c",
  null
  
)

export default component.exports